import { useMutation } from '@tanstack/vue-query';
import { dscvrApi } from '@/shared/api';

export const useOpenLootboxMutation = () => {
  return useMutation({
    mutationKey: ['open-lootbox-mutation'],
    mutationFn: dscvrApi.lootbox.openLootbox,
  });
};
